import React from 'react';
import { Button, Stack, Typography } from '@mui/material';

export default function RunStatusNotice({ error, retry, fetching }) {
  if (!error || error.authHandled) return null;
  return (
    <Stack direction="row" alignItems="center" spacing={1} role="status" sx={{ flexWrap: 'wrap' }}>
      <Typography variant="caption" color="text.secondary">Status unavailable. Progress may be out of date.</Typography>
      <Button size="small" onClick={() => retry()} disabled={fetching}>Retry status</Button>
    </Stack>
  );
}
